import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { ICustomerContact } from "../../../../Orchestrator/Types/Index";
import { UpdatePassengerReqType } from "../../../../Orchestrator/Types/Types/Passenger/PassengerType";

export class UpdatePassengerDataAction extends BaseAction<{updatedCustomer: ICustomerContact | null}, UpdatePassengerReqType> {

    override async run(): Promise<{updatedCustomer: ICustomerContact | null}> {
        let updatedCustomer: ICustomerContact | null = null;
        try {
            const { userData, passengers, customerContact } = this.params!;
            if (userData) {
                updateRecoilState("customerContactStateAtom", {
                    ...customerContact,
                    firstName: userData.firstName || customerContact.firstName || "",
                    lastName: userData.lastName || customerContact.lastName || "",
                    email: userData.email || customerContact.email || "",
                    phoneNumber: userData.phoneNumber || customerContact.phoneNumber || "",
                })
                const updatedContact = {
                    ...customerContact,
                    firstName: userData.firstName || customerContact.firstName || "",
                    lastName: userData.lastName || customerContact.lastName || "",
                    email: userData.email || customerContact.email || "",
                    phoneNumber: userData.phoneNumber || customerContact.phoneNumber || "",
                };
                updatedCustomer = updatedContact
            } else if (passengers.length > 0) {
                const firstPassenger = passengers[0];
                updateRecoilState("customerContactStateAtom", {
                    ...customerContact,
                    firstName: customerContact.firstName || firstPassenger.detail?.firstName || "",
                    lastName: customerContact.lastName || firstPassenger.detail?.lastName || "",
                    email: customerContact.email || firstPassenger.detail?.email || "",
                    phoneNumber: customerContact.phoneNumber || firstPassenger.detail?.phoneNumber || "",
                });

                const updatedContact = {
                    ...customerContact,
                    firstName: customerContact.firstName || firstPassenger.detail?.firstName || "",
                    lastName: customerContact.lastName || firstPassenger.detail?.lastName || "",
                    email: customerContact.email || firstPassenger.detail?.email || "",
                    phoneNumber: customerContact.phoneNumber || firstPassenger.detail?.phoneNumber || "",
                };
                updatedCustomer = updatedContact
            }
        } catch (error) {
            console.error("Error in UpdatePassengerDataAction:", error);
        } finally {
            return { updatedCustomer }
        }
    }
}

// Create a singleton instance
export const updatePassengerDataAction = new UpdatePassengerDataAction(); 